import { useCart } from './cart-context'
import { buildInquiryMessage, whatsAppChatUrl, type PricingKind } from '@/lib/whatsapp'
import { STORE_WHATSAPP_NUMBER } from '@/lib/env'

export function useWhatsAppCart() {
  const { items } = useCart()

  function openWhatsApp(kind: PricingKind) {
    if (items.length === 0) return

    const message = buildInquiryMessage(
      kind,
      items.map((item) => ({
        name: item.name,
        quantity: item.quantity,
        url: `${window.location.origin}/productos/${item.productId}`,
      })),
    )
    window.open(whatsAppChatUrl(STORE_WHATSAPP_NUMBER, message), '_blank')
  }

  return { openWhatsApp }
}
